// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createStoreLegal = (client) => ({
    /**
     * `GET /store/legal/platform-terms`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreLegalPlatformTermsRetrieve
     * @source apps/backend/src/api/store/legal/platform-terms/route.ts
     */
    listPlatformTerms: (query, headers) => client.fetch("/store/legal/platform-terms", { method: "GET", query, headers }),
});
//# sourceMappingURL=legal.js.map